export default __webpack_public_path__ + "static/media/stat-block-bg.73a9b960.jpg";